import { Feature } from '../../components/feature';
import Button from '../../components/Button';
import { Bot, ChartLine, MessageCircle } from 'lucide-react';
import Text from '../../components/Text';
import classNames from 'classnames';
import React from 'react';

const points = [
    { icon: <MessageCircle className="w-6 h-6 text-[#4949DE]" strokeWidth={1.5} />, title: "Personalized Messages", description: "Every parent gets a custom, caring message — not a generic alert." },
    { icon: <ChartLine className="w-6 h-6 text-[#4949DE]" strokeWidth={1.5} />, title: "360° child progress", description: "Attendance, marks, homework, behaviour — all studied together to give useful next steps." },
    { icon: <Bot className="w-6 h-6 text-[#4949DE]" strokeWidth={1.5} />, title: "AI Tutor in WhatsApp", description: "Students get step-by-step help anytime — not just answers, but learning." },
]


export default function Whatsapp() {
    return<Feature
                badge={"ADD ONS"}
                title={"AI-Powered WhatsApp"}
                description={
                    <div className='space-y-8'>
                        <p>
                            Connect smarter. Teach smarter. Grow faster. Make WhatsApp your school's 24×7 communication and learning hub — simple, personal, and automatic.
                        </p>
                        <div className="space-y-4 md:text-left">
                            {points?.map((item, index) => <MediaCard key={"asdnasjdkaskjdbasmndbasnd" + index} {...item} />)}
                        </div>
                    </div>
                }
                imageAlt="startup"
                imageQuery="images/new-landing-page/whatsAppv2.png"
                cta={
                    <div className="mt-8 flex items-center gap-6 md:flex-col md:justify-center">
                        <Button label='Activate AI-Powered WhatsApp' type='gradient' />
                        <Button label="Join Live Webinar" type='outlined' />
                    </div>
                }
            />
}

interface MediaCardProps {
    icon: React.ReactNode | string;
    title: string | React.ReactNode;
    description: string | React.ReactNode;
    cName?: string;
}

export const MediaCard = ({ icon, title, description, cName }: MediaCardProps) => {
    return <div className={classNames("flex items-center gap-4", cName)}>
        {/* Icon Container */}
        <div className="flex-shrink-0">
            <div className="flex justify-center items-center bg-[#4949DE1A] rounded-lg w-10 h-10">
                {!!icon && icon}
            </div>
        </div>

        {/* Content */}
        <div className="flex-1">
            {!!title && <Text type={"cardTitle"} cName="text-balance text-md font-semibold tracking-tight text-[#0C0C0C]" label={title} />}
            {!!description && <Text type="description" cName="text-xs text-[#4D4D4D] text-pretty font-medium" label={description} />}
        </div>
    </div>
}